import { isPresent } from '@ais-ui/utils';
import { Filter } from '@ais-ui/websockets';
import { ShipList } from '@ais-ui/api-spec/config';
import { FilterCriteria } from './constants';

const filterFilterByName = (filter: Filter, name: string): Filter | null => {
  if (filter.name?.toLowerCase().includes(name)) {
    return filter;
  }

  return null;
};

export const filterFilters = (filters: Filter[], name: string) => {
  const lowercaseName = name.toLowerCase();
  return filters
    .map((filter) => filterFilterByName(filter, lowercaseName))
    .filter(isPresent);
};

const filterShipListsByName = (
  shiplist: ShipList,
  name: string
): ShipList | null => {
  if (shiplist.name?.toLowerCase().includes(name)) {
    return shiplist;
  }

  return null;
};

export const filterShipLists = (shiplists: ShipList[], name: string) => {
  const lowercaseName = name.toLowerCase();
  return shiplists
    .map((shiplist) => filterShipListsByName(shiplist, lowercaseName))
    .filter(isPresent);
};

export const isComplexFilter = (filterDefinition: string): boolean => {
  try {
    // Try to parse using translateAutoCompleteValue

    // Check for parentheses in the original definition, but exclude those within quotes
    let checkString = filterDefinition;
    const quotedSegments = filterDefinition.match(/"[^"]*"/g) || [];

    // Remove quoted segments from the string we're checking
    quotedSegments.forEach((segment) => {
      checkString = checkString.replace(segment, '');
    });

    // Now check for parentheses in what remains (structural parts, not values)
    const hasStructuralParentheses =
      checkString.includes('(') || checkString.includes(')');

    // Check for * wildcards INSIDE quoted segments
    // A filter is considered complex if there's a * character inside a quoted value
    // that's not at the beginning or end of that quoted value
    let hasComplexWildcard = false;

    // Check each quoted segment for stars not at beginning or end
    for (const segment of quotedSegments) {
      // Remove the quotes to get just the value
      const value = segment.slice(1, -1);

      if (value.includes('*')) {
        // Count stars in the quoted value
        const starCount = (value.match(/\*/g) || []).length;

        // Calculate allowed stars (beginning and end only)
        const allowedStarCount =
          (value.startsWith('*') ? 1 : 0) + (value.endsWith('*') ? 1 : 0);

        // If there are more stars than allowed positions, it's complex
        if (starCount > allowedStarCount) {
          hasComplexWildcard = true;
          break;
        }
      }
    }

    return hasStructuralParentheses || hasComplexWildcard;
  } catch (error) {
    // If translation fails, consider it complex
    return true;
  }
};

export const isFilterApplied = (
  filter: Filter,
  selectedFilters: Filter[]
): boolean => {
  return selectedFilters.some(
    (selectedFilter) => selectedFilter.uuid === filter.uuid
  );
};

export const checkIsBooleanField = (types: string[]): boolean => {
  return types.includes('boolean');
};

export function getValueTypesByField(
  field: string | undefined,
  filterOptions: Record<string, FilterCriteria>
): Array<'string' | 'number' | 'boolean'> {
  if (!field) {
    return [];
  }

  const uppercasedField = field.toUpperCase();

  if (Object.prototype.hasOwnProperty.call(filterOptions, uppercasedField)) {
    return filterOptions[uppercasedField].data_types;
  }

  return [];
}
